import React from "react";
import { CheckCircle2 } from "lucide-react";
import { Button } from "../ui/button";
import { Spinner } from "../ui/spinner";

interface PricingOptionProps {
  title: string;
  price: string;
  features: string[];
  onPurchase: (productId: string, billingPeriod: "monthly" | "yearly") => void;
  billingPeriod: "monthly" | "yearly";
  productId: string;
  isPaymentLoading?: boolean;
}

const PricingOption: React.FC<PricingOptionProps> = ({
  title,
  price,
  features,
  onPurchase,
  billingPeriod,
  productId,
  isPaymentLoading,
}) => {
  return (
    <div className="w-full sm:w-80">
      <div className="rounded-2xl border border-border bg-card p-8 shadow-sm hover:shadow-md transition-shadow flex flex-col gap-6">
        <div>
          <h3 className="text-foreground font-bold text-xl mb-4">{title}</h3>
          <div className="flex items-end gap-1">
            <span className="font-bold text-foreground text-4xl">{price}</span>
            <span className="text-sm text-muted-foreground pb-1">
              {billingPeriod === "yearly" ? "/mo, billed yearly" : "/month"}
            </span>
          </div>
        </div>

        <ul className="flex flex-col gap-2">
          {features.map((feature, index) => (
            <li key={index} className="flex items-start gap-2 text-sm text-foreground/80">
              <CheckCircle2 className="h-4 w-4 text-primary shrink-0 mt-0.5" />
              <span>{feature}</span>
            </li>
          ))}
        </ul>

        {isPaymentLoading ? (
          <div className="flex justify-center py-2">
            <Spinner />
          </div>
        ) : (
          <Button
            disabled={isPaymentLoading}
            onClick={() => onPurchase(productId, billingPeriod)}
            className="w-full"
            size="lg"
          >
            Purchase Now
          </Button>
        )}
      </div>
    </div>
  );
};

export default PricingOption;
